import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';
import BillboardMovieItem from '../components/BillboardMovieItem';
import { FaFire } from 'react-icons/fa';
import Spinner from '../components/Spinner';
import { toast } from 'react-toastify';

export default function AweitBillboard() {
    const [movies, setMovies] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch movies sorted by views
    useEffect(() => {
        async function fetchMovies() {
            try {
                const moviesRef = collection(db, 'movies');
                const q = query(moviesRef, orderBy('views', 'desc'), limit(10));
                const querySnap = await getDocs(q);
                const moviesData = querySnap.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setMovies(moviesData);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching movies:", error);
                toast.error("Could not fetch movies");
                setLoading(false);
            }
        }
        fetchMovies();
    }, []);

    if (loading) {
        return <Spinner />;
    }

    return (
        <div className="min-h-screen bg-gray-900 py-12 px-4">
            {/* Billboard Background */}
            <div className="relative max-w-4xl mx-auto">
                {/* Wooden Frame Background */}
                <div className="absolute inset-0 bg-gradient-to-b from-gray-800 to-gray-700 rounded-xl shadow-2xl border-8 border-[#8B4513] transform rotate-1 -z-10">
                    <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cork-wallet.png')] opacity-50"></div>
                </div>

                {/* Pinned Paper Effect */}
                <div className="relative bg-white bg-opacity-90 rounded-lg p-8 shadow-lg transform -rotate-1">
                    {/* Title */}
                    <h1 className="text-4xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-[#FF1493] via-[#FF8C00] to-[#FFD700] mb-6 drop-shadow-lg">
                        AweitBillboard
                    </h1>

                    {/* Subtitle with Fire Icon */}
                    <div className="flex items-center justify-center space-x-2 mb-8">
                        <FaFire className="text-orange-500 text-3xl animate-pulse" />
                        <h2 className="text-2xl font-semibold text-gray-800">TOP TRENDING MOVIES TODAY</h2>
                    </div>

                    {/* Movie List */}
                    {movies.length > 0 ? (
                        <div className="space-y-4">
                            {movies.map((movie, index) => (
                                <BillboardMovieItem
                                    key={movie.id}
                                    movie={movie}
                                    rank={String(index + 1).padStart(2, '0')} // e.g., "01", "02"
                                />
                            ))}
                        </div>
                    ) : (
                        <p className="text-center text-gray-600 text-lg">No trending movies available.</p>
                    )}
                </div>

                {/* Pin Effects */}
                <div className="absolute top-0 left-0 w-8 h-8 bg-red-500 rounded-full -mt-4 -ml-4 shadow-md"></div>
                <div className="absolute top-0 right-0 w-8 h-8 bg-blue-500 rounded-full -mt-4 -mr-4 shadow-md"></div>
                <div className="absolute bottom-0 left-0 w-8 h-8 bg-yellow-500 rounded-full -mb-4 -ml-4 shadow-md"></div>
                <div className="absolute bottom-0 right-0 w-8 h-8 bg-green-500 rounded-full -mb-4 -mr-4 shadow-md"></div>
            </div>
        </div>
    );
}